import React, { useContext, useEffect, useState } from "react";
import { AiFillCheckCircle } from "react-icons/ai";
import { CgRadioCheck } from "react-icons/cg";
import styled from "styled-components";
import { UserStoryContext } from "../context/UserStoryState";
import Modal from "./Modal";
import OpCodeEditForm from "./OpCodeEditForm";
import { LoaderSpinner } from "./LoaderSpinner";
import { Checkbox } from "./ui/checkbox";
import { httpRequest1, httpRequest2 } from "../utils/httpsRequest";
import OpCodeViewDetail2 from "./OpCodeViewDetail2";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "src/components/ui/dialog";
import { Badge } from "src/components/ui/badge";
import { Card, CardContent, CardHeader, CardTitle } from "src/components/ui/card";
import { AppLoader } from "./LoaderSpinner";
import { BarChart } from 'lucide-react'
import {
    TableHead,
    TableRow,
    TableHeader,
    TableCell,
    TableBody,
    Table,
} from "./ui/table";
import { Button } from "./ui/button";
import { MdOutlineModeEdit } from "react-icons/md";
import { Layout } from "lucide-react"

const NoData = styled.div`
    width: 100%;
    font-size: 18px;
    text-align: center;
    margin: 20px 0;
    font-weight: bolder;
    padding: 20px;
`;

export default function OpCodeTable({
    OpCodeEditTemplateName,
    tableName,
    tableCol,
    tableData,
    totalFetchedRow = 0,
    tableDisplayOrder = "row",
    haveSelect = false,
    contextField = false,
    data = false,
    templateName = false,
    isFetching,
    allFrameData = false,
    setAllFrameData = false,
    details = false,
    edit = false,
    displayDetailsbtn = false,
    // Delete = {
    //     condition: "registrationOpeningDate=2024-08-19",  // comma-separated key-value pairs
    //     table: "tableName"  // optional: table name or identifier if needed for context
    // },  // New Delete prop, default is false
    Delete = false,
}) {
    const [toggleButtonId, setToggleButtonId] = React.useState(null);
    const [showModal, setShowModal] = React.useState(false);
    const [editRecordId, setEditRecordId] = React.useState(null);
    const [ShowViewDetails, setShowViewDetails] = React.useState(null);
    const { SetViewDetailData, AddContextData } = useContext(UserStoryContext);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 10000);
        return () => clearTimeout(timer);
    }, []);

    const handleRowClick = (userId) => {
        const selectedRecord = tableData.tableRow.find((item) => item.recordId === userId);
        sendContextData(data.entityName, contextField, selectedRecord);
        setToggleButtonId(userId);
        if (haveSelect) {
            SetViewDetailData(tableName, userId);
        }
    };

    const handleViewDetailsClick = (item) => {

        setShowViewDetails(item);
    };

    const handleDeleteClick = (item) => {
        // Implement your delete logic here
        console.log("Delete clicked for record:", item);
        // Example: call a delete API or update the state
    };

    const sendContextData = (tableName, contextField, viewDetails) => {
        const contextFields = contextField;
        let temp = {};
        let mergedData = {};

        for (const item of contextFields) {
            temp[item] = viewDetails[item] || "";
            if (viewDetails[item]) {
                if (item === "recordId") {
                    mergedData[tableName + "_recid"] = viewDetails[item];
                    mergedData["cc" + tableName.charAt(0).toUpperCase() + tableName.slice(1)] = viewDetails[item];
                } else {
                    mergedData[item] = viewDetails[item];
                }
            }
        }

        AddContextData(mergedData);
    };
    // // Helper function to parse and check conditions
    // const checkDeleteConditions = (item, deleteConditions) => {
    //     if (!deleteConditions || deleteConditions === true) return true;

    //     // Extract conditions if `Delete` is a string with comma-separated conditions
    //     const conditions = deleteConditions.condition
    //         .split(",")
    //         .map((cond) => cond.split("="))
    //         .map(([key, value]) => ({ key: key.trim(), value: value.trim() }));

    //     // Check if all conditions match the item
    //     return conditions.every((condition) => item[condition.key] === condition.value);
    // };

    // Helper function to parse and check conditions
    const checkDeleteConditions = (item, deleteConditions) => {
        // If no conditions or if `Delete` is set to `true`, always show the Delete button
        if (!deleteConditions || deleteConditions === true) return true;

        // Extract conditions if `Delete` is a string with comma-separated conditions
        const conditions = deleteConditions.condition
            .split(",")
            .map((cond) => cond.split("="))
            .map(([key, value]) => ({ key: key.trim(), value: value.trim() }));

        // Hide the Delete button only if all conditions match the item exactly
        return !conditions.every((condition) => item[condition.key] === condition.value);
    };

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showModal]);

    return (

        <div className="overflow-auto ">
            <Table>
                {isFetching === false ? (
                    tableCol && totalFetchedRow > 0 ? (
                        <>
                            <TableHeader className="bg-gray-50 pt-4">
                                <TableRow className="bg-gray-100">
                                    {tableCol && (
                                        <>
                                            {haveSelect && <TableHead className="w-[32px] py-10"></TableHead>}
                                            {tableCol.map((item, index) =>
                                                item.visible !== false && (
                                                    <TableHead
                                                        className="text-[#0B236B]"
                                                        key={index}
                                                        style={{
                                                            width: item.size,
                                                            maxWidth: item.size,
                                                        }}
                                                    >
                                                        {item.title}
                                                    </TableHead>
                                                )
                                            )}
                                            <TableHead></TableHead>
                                        </>
                                    )}
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {tableDisplayOrder === "row" &&
                                    tableData &&
                                    tableData.tableRow &&
                                    tableData.tableRow.length > 0 &&
                                    tableData.tableRow.map((item, itemIndex) => (
                                        <TableRow key={itemIndex}>
                                            {haveSelect && (
                                                <TableCell
                                                    style={{
                                                        width: "30px",
                                                        textAlign: "center",
                                                    }}
                                                >
                                                    <div onClick={() => handleRowClick(item.recordId)} className="toggle-button">
                                                        {toggleButtonId === item.recordId ? (
                                                            <AiFillCheckCircle
                                                                style={{
                                                                    color: "green",
                                                                    fontSize: "23px",
                                                                }}
                                                            />
                                                        ) : (
                                                            <CgRadioCheck
                                                                style={{
                                                                    fontSize: "23px",
                                                                }}
                                                            />
                                                        )}
                                                    </div>
                                                </TableCell>
                                            )}
                                            {tableCol.map(
                                                (tableItem, index) =>
                                                    tableItem.visible !== false && (
                                                        <TableCell
                                                            key={index}
                                                            style={{
                                                                width: tableItem.size,
                                                                maxWidth: tableItem.size,
                                                            }}
                                                        >
                                                            {item[tableItem.field]}
                                                        </TableCell>
                                                    )
                                            )}
                                            <TableCell
                                                style={{
                                                    width: "50px",
                                                    textAlign: "center",
                                                }}
                                            >
                                                {edit && (
                                                    <Button
                                                        onClick={() => {
                                                            setShowModal((prev) => !prev);
                                                            setEditRecordId(item.recordId);
                                                        }}
                                                    >
                                                        Edit
                                                        <MdOutlineModeEdit className="ml-2 mr-0 h-4 w-4" />
                                                    </Button>
                                                )}
                                                {displayDetailsbtn && (
                                                    <Button
                                                        onClick={() => handleViewDetailsClick(item)}
                                                        style={{ marginLeft: "10px" }}
                                                        variant="secondary"
                                                    >
                                                        View Details
                                                    </Button>
                                                )}
                                                {Delete && checkDeleteConditions(item, Delete) && (
                                                    <Button
                                                        onClick={() => handleDeleteClick(item)}
                                                        style={{ marginLeft: "10px", backgroundColor: "red", color: "white" }}
                                                        className="text-white bg-red-600 hover:bg-red-700"
                                                    >
                                                        Delete
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>

                            {/* Modal for Editing */}
                            {tableData && showModal && (
                                <Modal $isOpen={showModal} setOpenModal={setShowModal}>
                                    <Modal.Header>OP Code Edit Form</Modal.Header>
                                    <Modal.Body>
                                        <OpCodeEditForm
                                            recordId={editRecordId}
                                            templateName={OpCodeEditTemplateName}
                                            tableName={tableName}
                                        />
                                    </Modal.Body>
                                </Modal>
                            )}
                            {/* Dialog for View Details */}
                            {ShowViewDetails && (
                                <Dialog open={!!ShowViewDetails} onOpenChange={() => setShowViewDetails(null)}>
                                    <DialogContent className="max-w-4xl max-h-[80vh] overflow-y-auto">
                                        <DialogHeader className="relative">
                                            <DialogTitle className="text-3xl font-bold mb-4">{details.Title}</DialogTitle>
                                        </DialogHeader>
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 p-4">
                                            {details.fields.map((field, index) => (
                                                <Card
                                                    key={index}
                                                    className={field.type === "fullCard" ? "col-span-1 md:col-span-2" : "col-span-1"}
                                                    style={{ background: field.background }}
                                                >
                                                    <CardContent className="pt-6">
                                                        <div className="flex items-center space-x-2 mb-4">
                                                            <Layout className="h-5 w-5 text-blue-500" />
                                                            <h3 className="text-lg font-semibold">{field.title}</h3>
                                                        </div>
                                                        {field.badges && (
                                                            <div className="flex space-x-2 mb-4">
                                                                {field.badges.map((badge, badgeIndex) => (
                                                                    <Badge key={badgeIndex} variant={badge.variant}>
                                                                        {badge.title}
                                                                    </Badge>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {field.data && (
                                                            <div className={`grid grid-cols-${field.dataDispay === "sidebyside" ? "2" : "1"} gap-4`}>
                                                                {field.data.map((dataItem, dataIndex) => (
                                                                    <p key={dataIndex}>
                                                                        <span className="font-medium">{dataItem.title}: </span>
                                                                        {ShowViewDetails[dataItem.field] || "N/A"}
                                                                    </p>
                                                                ))}
                                                            </div>
                                                        )}
                                                        {field.billing && (
                                                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                                                                {field.billing.map((billingItem, billingIndex) => (
                                                                    <div
                                                                        key={billingIndex}
                                                                        className="p-4 rounded-md"
                                                                        style={{ backgroundColor: billingItem.color || "inherit" }}
                                                                    >
                                                                        <p className="font-medium">{billingItem.title}</p>
                                                                        <p className="text-2xl font-bold">
                                                                            {ShowViewDetails[billingItem.field] ? `$${ShowViewDetails[billingItem.field]}` : "N/A"}
                                                                        </p>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                    </CardContent>
                                                </Card>
                                            ))}
                                        </div>
                                    </DialogContent>
                                </Dialog>
                            )}
                        </>
                    ) : (
                        loading ? (
                            <div style={{ height: '300px', width: '100%', background: '#f0f0f0' }}>
                                <AppLoader size={40} color="text-black-500" />
                            </div>
                        ) : (
                            <NoData>No Data Found!</NoData>
                        )
                    )
                ) : (
                    <NoData>
                        <LoaderSpinner />
                    </NoData>
                )}
            </Table>
        </div>

    );
}
